export default {
  getTeamData: state => state.teamEdited,
  getTeams: state => state.teams,
  getActiveTeams: state => state.activeTeams,
  statisticsCurrent: state => state.statisticsCurrent,
}
